import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { InfoScreenDto } from "../models/info-screen.model";
import { ConfigService } from "@evonik/ng-core";

@Injectable({ providedIn: 'root' })
export class InfoScreenService {
    private readonly http = inject(HttpClient);
    private readonly config = inject(ConfigService);

    private readonly apiPath = 'dotnet-api/Infoscreen';

    private getUrl(): string {
        return this.config.getConfig().get('apiBaseUrlNet');
    }

    getAll(): Observable<InfoScreenDto[]> {
        return this.http.get<InfoScreenDto[]>(`${this.getUrl()}/${this.apiPath}`);
    }

    update(messageKey: string): Observable<boolean> {

        if (!messageKey) {
            throw new Error('Info Screen needs an key to update');
        }

        return this.http.put<boolean>(`${this.getUrl()}/${this.apiPath}?messageKey=${messageKey}`, []);
    }
}
